/*
 * Framer motion allows for more advanced animations, and relies on Javascript objects for transition values, which are  * centralized here. For css tokens, see animations.module.css in spine-css.
 */

const fadeIn = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
};

const appearFromBottomExitRight = {
    hidden: { opacity: 0, y: 5 },
    show: { opacity: 1, y: 0 },
    exit: { opacity: 0, x: 10 },
};

const fadeUpStart = {
    y: 20,
    opacity: 0,
};

const fadeUpEnd = {
    y: 0,
    opacity: 1,
};

const fadeSlideInRight = {
    hidden: { opacity: 0, x: 15 },
    show: { opacity: 1, x: 0 },
};

const fadeStaggerChildren = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
        },
    },
};

// Transitions (can be physics-based or time-based)
const subtleSpring = {
    type: 'spring',
    stiffness: 120,
    damping: 15,
};

const ms200 = {
    duration: 0.2,
};

const ms300 = {
    duration: 0.3,
};

export {
    fadeIn,
    fadeUpStart,
    fadeUpEnd,
    fadeSlideInRight,
    fadeStaggerChildren,
    subtleSpring,
    appearFromBottomExitRight,
    ms200,
    ms300,
};
